export class DeliveryOption {
    id?: number;
    name?: string;
    deliveryFee?: number;
    handlingFee?: number;
    freeDeliveryLimit?:number;
    freeDeliveryAllowed?:boolean;
}
